import * as CommunicationStatus from 'src/constants/communication-status'
import { mapState } from 'vuex'

export default {
  data: () => ({
    isContactLegConnected: false
  }),

  computed: {
    ...mapState(['dialer'])
  },

  watch: {
    'dialer.communication': {
      deep: true,
      immediate: true,
      handler (communication) {
        // Tracks whether the contact (customer leg) is actually connected, which
        // is what gates voicemail drop. The overall current_status2 turns
        // "in progress" the moment the agent joins the conference — before the
        // contact answers — so it can't be used here; the customer leg's own
        // status is the real "contact is on the line" signal and mirrors the
        // backend's voicemail-drop guard.
        if (communication?.customer_leg_status === CommunicationStatus.STATUS_INPROGRESS_NEW) {
          this.isContactLegConnected = true
          return
        }

        this.isContactLegConnected = false
      }
    }
  }
}
